import {
  ICalendarHoliday,
  ITimeOffRequest,
  IMentionAttachmentComment,
  IUserData,
  TimeOffRequest,
  TimeOffRequestComment,
  TimeOffStateEnum,
  TimeOffType,
  IUser,
  User
} from '@/models';
import { ITransition } from '@/models/transition';
import { ITimeOffRequestState } from '@/store/timeoff-request';
import moment from 'moment';

import { ITimeOffRequestGetters } from './getters.types';

export const getters: ITimeOffRequestGetters = {
  getTimeOffCount(state: ITimeOffRequestState): number {
    return state.count;
  },

  getTimeOffRequests(state: ITimeOffRequestState): ITimeOffRequest[] {
    return state.timeOffRequests.map(data => new TimeOffRequest(data));
  },

  getTimeOffRequestById: (state: ITimeOffRequestState) => (
    id: number
  ): ITimeOffRequest | undefined => {
    const data = state.timeOffRequests.find(timeOff => timeOff.id === id);
    if (!data) {
      return undefined;
    }

    return new TimeOffRequest(data);
  },

  getCalendarTimeOffs: (
    state: ITimeOffRequestState,
    getters: ITimeOffRequestGetters,
    rootState: any,
    rootGetters: any
  ) => (calendars: number[]): ITimeOffRequest[] => {
    const calendarTimeOffHolidays = rootGetters[
      'timeOffCalendar/getCalendarsHolidays'
    ](calendars).map(
      (data: ICalendarHoliday) =>
        new TimeOffRequest({
          id: data.id,
          state: data.is_paid
            ? TimeOffStateEnum.PaidHoliday
            : TimeOffStateEnum.UnpaidHoliday,

          type: data.is_paid
            ? new TimeOffType({ name: 'Paid Holiday' })
            : new TimeOffType({ name: 'Unpaid Holiday' }),

          name: data.name,

          type_requested_subtype: 0,

          entitlement_year: moment(data.date).get('year'),

          start: moment(data.date).format('YYYY-MM-DD'),
          end: moment(data.date).format('YYYY-MM-DD'),
          calendar: data.calendar
        })
    );

    const calendarTimeOffs = [] as ITimeOffRequest[];

    state.timeOffRequests.forEach(data => {
      if (
        data.state != TimeOffStateEnum.Rejected &&
        data.state != TimeOffStateEnum.Cancelled
      ) {
        const timeOff = new TimeOffRequest(data);
        calendarTimeOffs.push(timeOff);
      }
    });

    return calendarTimeOffHolidays.concat(calendarTimeOffs);
  },

  getUnapprovedEmployeesTimeOff(
    state: ITimeOffRequestState
  ): ITimeOffRequest[] {
    return state.unapprovedTimeOffRequests.map(
      data => new TimeOffRequest(data)
    );
  },

  getTimeOffRequestActivities: (state: ITimeOffRequestState): ITransition[] => {
    return state.activities;
  },

  getTimeOffRequestComments: (
    state: ITimeOffRequestState
  ): IMentionAttachmentComment[] => {
    return state.comments.map(data => new TimeOffRequestComment(data));
  },

  getTimeOffRequestCommentById: (state: ITimeOffRequestState) => (
    id: number
  ): IMentionAttachmentComment | undefined => {
    const data = state.comments.find(comment => comment.id === id);
    if (!data) {
      return undefined;
    }

    return new TimeOffRequestComment(data);
  },

  getLastCreatedTimeOffRequestCommentId(
    state: ITimeOffRequestState
  ): number | null {
    return state.lastCreatedRequestCommentId;
  },
  // Mentions
  getTimeOffRequestMentionableUsers(state: ITimeOffRequestState): IUser[] {
    return state.mentionableUsers.map(data => new User(data));
  }
};
